import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingScreen from "../../lib/constants/loadingScreen";
import { appointmentContext } from "../../pages/viewCompletedAppointmentsStaff";

const EndedActionAppointment = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const {
    appointmentId,
    appointmentNumber,
    full_name,
    problem,
    report,
    status,
    referDoctorAvailable,
  } = useContext(appointmentContext);
  let appointment_status;
  const navigate = useNavigate();
  const [actionLoading, setActionLoading] = useState(false);

  const config = {
    headers: {
      Authorization:
        "Bearer " +
        (localStorage.getItem("doctorticket") ||
          localStorage.getItem("staffticket")),
    },
  };

  const handleButtonClick = async () => {
    if (status == "Ended" && referDoctorAvailable === null) {
      updateAppointmentStatus();
    } else if (
      status == "Ended" &&
      (referDoctorAvailable === undefined || referDoctorAvailable !== null)
    ) {
      console.log("Clicked");
      navigate(
        `/dashboard/staff/add/followup/datetime/appointment/${appointmentId}`
      );
    }
  };

  const updateAppointmentStatus = () => {
    // referDoctorAvailable => refer.toDoctor (assumes as referred patient without referred doctor)
    appointment_status = "Referred";

    if (
      window.confirm("Are you sure want to change this appointment status?")
    ) {
      setActionLoading(true);
      const data = {
        appointmentStatus: appointment_status,
      };

      axios
        .put(
          `${apiBaseUrl}/staff/updateAppointmentStatus/` + appointmentId,
          data,
          config
        )
        .then((response) => {
          if (response.data.msg == "Updated Status") {
            if (appointment_status == "Referred") {
              toast.success("Appointment Referred", {
                position: "bottom-right",
              });
            } else {
              toast.success("Appointment sent to follow_up", {
                position: "bottom-right",
              });
            }
            window.location.reload();
          } else {
            toast.failed("Failed To Update", {
              position: "bottom-right",
            });
          }
        })
        .catch((err) => {
          console.error("Error updating appointment status:", err);
          toast.error(
            "Failed to update appointment status! Please try again.",
            {
              position: "bottom-right",
            }
          );
        })
        .finally(() => {
          setActionLoading(false);
        });
    }
  };

  return (
    <>
      {actionLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-80">
          <LoadingScreen />
        </div>
      )}

      <div className="bg-white px-4 pt-6">
        <div className="sm:flex sm:items-start">
          <div className="mt-3 text-center sm:text-left">
            <h1
              className="text-3xl leading-6 font-medium text-center text-gray-900"
              id="modal-title"
            >
              Actions
            </h1>
            <div className="">
              <p className="text-sm text-gray-500 mx-5">
                <div class="py-2 mx-5">
                  <ul class="my-4 space-y-3 mx-8">
                    <li>
                      <Link
                        to={`/dashboard/viewreport/${appointmentId}`}
                        state={{ report, appointmentNumber, full_name }}
                        className="flex items-center px-12 py-4 text-center font-bold text-black shadow rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow"
                      >
                        <span class="flex-1 whitespace-nowrap">
                          View Report
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`/dashboard/viewAppointmentbyDoctor/view/prescription/${appointmentId}`}
                        state={{ full_name, problem }}
                        className="flex items-center px-12 py-4 text-center font-bold text-black shadow rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow"
                      >
                        <span class="flex-1 whitespace-nowrap">
                          View Prescription
                        </span>
                      </Link>
                    </li>
                    <li>
                      <button
                        onClick={handleButtonClick}
                        className="flex items-center px-12 py-4 text-center font-bold text-black shadow rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow"
                      >
                        <span class="flex-1 whitespace-nowrap">
                          Arrange{" "}
                          {referDoctorAvailable != null ||
                          referDoctorAvailable === undefined
                            ? "Follow-Up"
                            : "Refer"}
                        </span>
                      </button>
                    </li>
                  </ul>
                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EndedActionAppointment;
